import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact'
import Bh from '../views/Bh'
import Work from '../views/Work'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta:{
      logo:{background:'#161717',color:'#FFFFFF',logoUrl:'logo-big.svg'}
    } 
  },
  {
    path: '/about',
    name: 'About',
    component:About,
    //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta:{
      logo:{background:'#FFFFFF',color:'#161717 ',logoUrl:'logo-big-black.svg'}
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component:Contact,
    //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta:{
      logo:{background:'#FFFFFF',color:'#161717 ',logoUrl:'logo-big-black.svg'}
    }
  },
  {
    path: '/bh',
    name: 'Bh',
    component:Bh,
    //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta:{
      logo:{background:'#FFFFFF',color:'#161717 ',logoUrl:'logo-big-black.svg'}
    }
  },
  {
    path: '/work',
    name: 'Work',
    component:Work,
    //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta:{
      logo:{background:'#FFFFFF',color:'#161717 ',logoUrl:'logo-big-black.svg'}
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base:'/',// process.env.BASE_URL
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.afterEach((to) => {
  if(process.env.NODE_ENV == "production"){
    //google analytics
    if(typeof ga !== 'undefined'){
      ga('set', 'page', to.path);
      ga('send', 'pageview');
    }
  }
});

export default router
